import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-same-workday-investigations-popover',
  templateUrl: './same-workday-investigations-popover.component.html',
  styleUrls: ['./same-workday-investigations-popover.component.scss']
})
export class SameWorkdayInvestigationsPopoverComponent {
  @Input() investigations: any[] = [];
}
